import React from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Container,
  IconButton,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { useTranslation } from "react-i18next";
import Footer from "../countryhomepagescomponent/Footer";
import News from "../countryhomepagescomponent/News";
import globalStyles from "../../../global";

const CareerPage = () => {
  const { t, i18n } = useTranslation();
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  const isRTL = i18n.dir() === "rtl";

  const styles = {
    root: {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      direction: isRTL ? "rtl" : "ltr",
    },
    heroBanner: {
      display: "flex",
      flexDirection: { xs: "column", md: isRTL ? "row-reverse" : "row" },
      bgcolor: "white",
      alignItems: "center",

      // padding: "0 30px",
    },
    imageContainer: {
      // display: { xs: "none", md: "block" },
      width: { md: "50%" },
      order: isRTL ? 1 : 2,
    },
    heroImage: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
    textContainer: {
      width: { xs: "100%", md: "50%" },
      py: 6,
      px: 3,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      order: isRTL ? 2 : 1,
    },
    innerContent: {
      maxWidth: "28rem",
      mx: "auto",
      width: "100%",
    },
    heroTitle: {
      fontSize: {
        md: "55px",
        sm: "36px",
        xs: "30px",
      },
      fontWeight: 400,
      mb: 3,
      color: globalStyles.colors.army_green,

      fontFamily: "AllRoundGothicBold",
      textTransform: "uppercase",
      textAlign: isRTL ? "right" : "left",
    },
    heroDescription: {
      fontSize: { sm: "24px", xs: "20px" },
      mb: 4,
      fontWeight: 400,
      fontFamily: globalStyles.fonts.primary,
      color: "#4D4D4D",
      textAlign: isRTL ? "right" : "left",
    },
    applyButton: {
      px: 6,
      py: 1,
      color: "white",
      fontSize: { sm: "18px", xs: "14px" }, 
      bgcolor: globalStyles.colors.uclean_green,
      borderRadius: 1,
      "&:hover": {
        bgcolor: globalStyles.colors.uclean_green,
        opacity: 0.9,
      },
    },
    talentTitle: {
      fontWeight: 600,
      mb: 3,
      color: globalStyles.colors.army_green,
      textAlign: "center",
      fontFamily: "Poppins",
      mt: 4,
      fontSize: {
        md: "32px",
        sm: "24px",
        xs: "22px",
      },
    },
    talentDescription: {
      fontSize: { sm: "20px", xs: "16px" },
      lineHeight: "26px",
      letterSpacing: "0%",
      mb: 4,
      fontWeight: 400,
      fontFamily: globalStyles.fonts.primary,
      textAlign: "centre",
      color: "#4D4D4D",
      mt: 2,
    },
    statsSection: {
      bgcolor: "#f5f5f0",
      borderRadius: 2,
      p: 2.5,
      mt: "-3%",
    },
    statItem: {
      textAlign: "center",
      p: 2,
    },
    statNumber: {
      fontSize: { md: "36px", sm: "26px", xs: "22px" },
      lineHeight: "auto",
      letterSpacing: "0%",
      fontWeight: 600,
      color: globalStyles.colors.army_green,
      fontFamily: globalStyles.fonts.primary,
    },
    statLabel: {
      color: "text.secondary",
      fontFamily: globalStyles.fonts.primary,
      fontSize: { sm: "19.2px", xs: "16px" },
      lineHeight: "auto",
      letterSpacing: "0%",
    },
    benefitsSection: {
      py: 6,
      bgcolor: "white",
      mt: 6,
    },
    benefitHeading: {
      fontSize: { md: "40px", sm: "28px", xs: "24px" },
      lineHeight: "auto",
      letterSpacing: "1%",
      fontWeight: 600,
      mb: 4,
      color: globalStyles.colors.army_green,
      // textAlign: isRTL ? "right" : "left",
      fontFamily: "AllRoundGothicBold",
      // textAlign: "center",
      textTransform: "uppercase",
    },
    benefitCard: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      p: 3,
    },
    benefitIcon: {
      width: "80px",
      height: "80px",
      objectFit: "contain",
      mb: 2,
    },
    benefitTitle: {
      fontSize: { sm: "22px", xs: "20px" },
      letterSpacing: "0%",
      fontWeight: 600,
      mt: 2,
      mb: 1.5,
      fontFamily: globalStyles.fonts.primary,
      color: "#003A26",
    },

    benefitDescription: {
      color: "text.secondary",
      fontFamily: globalStyles.fonts.primary,
      fontSize: { sm: "18px", xs: "14px" },
      lineHeight: "auto",
      letterSpacing: "0%",
    },

    joinSection: {
      py: 6,
      backgroundImage: `url(${imageBaseUrl}careerbg.png)`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      width: "100%",
    },
    socialSection: {
      // display: "flex",
      // flexDirection: "column",
      // alignItems: "center",
      py: 6,
      backgroundImage: `url(${imageBaseUrl}careerbg.png)`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      width: "100%",
      borderRadius: "16px",
      maxWidth: "1200px",
      mx: "auto",

      my: {
        sm: 8,
        xs: 4,
      },
    },
    socialTitle: {
      fontSize: { md: "45.45px", sm: "30px", xs: "26px" },
      fontWeight: 600,
      // mb: 4,
      color: globalStyles.colors.army_green,
      textAlign: "center",

      fontFamily: "AllRoundGothicBold",
      textTransform: "uppercase",
    },
    socialSubTitle: {
      fontSize: { md: "45.45px", sm: "30px", xs: "26px" },
      fontWeight: 600,
      mb: 2,
      color: globalStyles.colors.uclean_green,
      textAlign: "center",

      fontFamily: "AllRoundGothicBold",
      textTransform: "uppercase",
    },

    socialIconsContainer: {
      display: "flex",
      gap: 2,
      flexDirection: isRTL ? "row-reverse" : "row",
      justifyContent: "center",
      alignItems: "center",
    },
    socialIcon: {
      color: globalStyles.colors.army_green,
      fontSize: 40,
      transition: "all 0.2s ease-in-out",
      "&:hover": {
        color: globalStyles.colors.uclean_green,
        transform: "scale(1.1)",
      },
    },
    activeRolesSection: {
      py: 6,
      bgcolor: "white",
      textAlign: "center",
    },
    activeTitle: {
      fontSize: { md: "36px", sm: "28px", xs: "24px" },
      fontWeight: 600,
      pb: 4,
      color: globalStyles.colors.army_green,
      fontFamily: "AllRoundGothicBold",
      textTransform: "uppercase",
    },
    activeDescription: {
      fontSize: { sm: "18px", xs: "16px" },
      lineHeight: "26px",
      letterSpacing: "0%",
      mb: 4,
      fontWeight: 400,
      fontFamily: globalStyles.fonts.primary,
      color: "#4D4D4D",
      textAlign: "center",
    },
  };

  const careerStats = [
    { number: "12+", label: t("career.stats.offices") },
    { number: "700+", label: t("career.stats.employees") },
    { number: "7+", label: t("career.stats.departments") },
    { number: "2+", label: t("career.stats.regions") },
  ];

  const benefits = [
    {
      icon: "career_3.png",
      title: t("career.benefits.equalOpportunity.title"),
      description: t("career.benefits.equalOpportunity.description"),
    },

    {
      icon: "career_2.png",
      title: t("career.benefits.flexibleCulture.title"),
      description: t("career.benefits.flexibleCulture.description"),
    },
    {
      icon: "career_1.png",
      title: t("career.benefits.brandTrust.title"),
      description: t("career.benefits.brandTrust.description"),
    },
  ];

  const socialLinks = [
    {
      icon: <FacebookIcon />,
      url: "https://www.facebook.com/uclean.in",
      label: "Facebook",
    },
    {
      icon: <InstagramIcon />,
      url: "https://www.instagram.com/uclean.in",
      label: "Instagram",
    },
    {
      icon: <TwitterIcon />,
      url: "https://twitter.com/uclean_in",
      label: "Twitter",
    },
    {
      icon: <LinkedInIcon />,
      url: "https://www.linkedin.com/company/uclean",
      label: "LinkedIn",
    },
  ];

  return (
    <Box sx={styles.root}>
      <Box sx={styles.heroBanner}>
        <Box sx={styles.imageContainer}>
          <Box
            component="img"
            src={`${imageBaseUrl}career.png`}
            alt="UCLEAN Team"
            sx={styles.heroImage}
          />
        </Box>

        <Box sx={styles.textContainer}>
          <Box sx={styles.innerContent}>
            <Typography variant="h1" sx={styles.heroTitle}>
              {t("career.joinUs")}
            </Typography>
            <Typography sx={styles.heroDescription}>
              {t("career.joinUclean")}
            </Typography>
            <Box textAlign={isRTL ? "right" : "left"}>
              <Button sx={styles.applyButton}>{t("career.applyNow")}</Button>
            </Box>
          </Box>
        </Box>
      </Box>

      <Container sx={{ maxWidth: "1200px", width: "100%", mx: "auto" }}>
        <Box textAlign="center" py={6}>
          <Typography variant="h2" sx={styles.talentTitle}>
            {t("career.lookingForTalent")}
          </Typography>
          <Typography sx={styles.talentDescription} mx="auto">
            {t("career.talentDescription")}
          </Typography>
        </Box>

        <Grid container sx={styles.statsSection}>
          {careerStats.map((stat, index) => (
            <Grid item xs={12} md={3} key={index} sx={styles.statItem}>
              <Typography sx={styles.statNumber}>{stat.number}</Typography>
              <Typography sx={styles.statLabel}>{stat.label}</Typography>
            </Grid>
          ))}
        </Grid>

        <Box sx={styles.benefitsSection}>
          <Typography
            variant="h2"
            textAlign="center"
            sx={styles.benefitHeading}
            mb={6}
          >
            {t("career.benefits.title")}
          </Typography>
          <Grid
            container
            spacing={0}
            justifyContent="center"
            alignItems="stretch"
            sx={{ position: "relative" }}
          >
            {benefits.map((benefit, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Box sx={styles.benefitCard}>
                  <Box
                    component="img"
                    src={`${imageBaseUrl}${benefit.icon}`}
                    alt={benefit.title}
                    sx={styles.benefitIcon}
                  />
                  <Typography
                    sx={{ ...styles.benefitTitle, minHeight: "56px" }}
                  >
                    {benefit.title === "Flexible Work Culture" ? (
                      benefit.title
                    ) : benefit.title.split(" ").length > 2 ? (
                      <>
                        {benefit.title.split(" ").slice(0, -1).join(" ")} <br />
                        {benefit.title.split(" ").slice(-1)}
                      </>
                    ) : (
                      benefit.title
                    )}
                  </Typography>
                  <Typography sx={styles.benefitDescription}>
                    {benefit.description}
                  </Typography>
                </Box>

                {/* Render vertical divider only after first and second cards */}
                {index < benefits.length - 1 && (
                  <Box
                    sx={{
                      display: { xs: "none", md: "block" },
                      position: "absolute",
                      top: 0,
                      bottom: 0,
                      left: `${(index + 1) * (100 / 3)}%`,
                      transform: "translateX(-50%)",
                      borderLeft: "1px solid #BBBBBB",
                      height: "304px",
                    }}
                  />
                )}
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>

      {/* Active Roles Section */}
      <Box sx={styles.activeRolesSection}>
        <Typography variant="h1_gothic" sx={styles.activeTitle} mb={4}>
          {t("career.activeRolesTitle", "Active Roles")}
        </Typography>
        <Typography
          sx={{
            fontSize: { md: "28px", xs: "20px" },
        
            color: globalStyles.colors.army_green,
            mb: 2,
            fontWeight: 400,
            fontFamily: globalStyles.fonts.primary,
            textAlign: "center",
          }}
        >
          {t("career.activeRolesDescription")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            fontSize: { md: "20px", xs: "16px" },
            color: "#4D4D4D",
            fontWeight: 400,
            fontFamily: globalStyles.fonts.primary,
            textAlign: "center",
          }}
        >
          <Box component="span" sx={{ display: "flex", alignItems: "center" }}>
            <svg
              width="22"
              height="22"
              fill="#6FC41A"
              style={{ marginRight: 8 }}
            >
              <circle cx="11" cy="11" r="11" />
              <text x="11" y="16" textAnchor="middle" fontSize="14" fill="#fff">
                ✉
              </text>
            </svg>
            {t("career.activeRolesSendCV")}
          </Box>
          <Box
            component="a"
            href="mailto:hrd@uclean.in"
            sx={{
              color: globalStyles.colors.uclean_green,
              fontWeight: 600,
              textDecoration: "underline",
              ml: 1,
              fontSize: { md: "20px", xs: "16px" },
            }}
          >
            hrd@uclean.in
          </Box>
        </Box>
      </Box>

      {/* Social Media Section */}
      <Box sx={styles.socialSection}>
        <Container>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "baseline", // ⬅ important!
              flexWrap: { xs: "nowrap", md: "wrap" },
              gap: { xs: 0.5, md: 1 },
            }}
          >
            <Typography
              variant="h2"
              sx={{ ...styles.socialTitle, display: "inline" }}
            >
              {t("career.interested")}{" "}
              <Typography
                variant="h2"
                sx={{ ...styles.socialSubTitle, display: "inline" }}
              >
                {t("career.interestedSubTitle")}
              </Typography>
            </Typography>
          </Box>

          <Box sx={styles.socialIconsContainer}>
            {socialLinks.map((social, index) => (
              <IconButton
                key={index}
                component="a"
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
                sx={styles.socialIcon}
              >
                {social.icon}
              </IconButton>
            ))}
          </Box>
        </Container>
      </Box>

      <News />
      <Box sx={{ height: { sm: "80px", xs: "20px" } }} />
      <Footer />
    </Box>
  );
};

export default CareerPage;
